import script from "./HrDate.vue?vue&type=script&setup=true&lang=js"
export * from "./HrDate.vue?vue&type=script&setup=true&lang=js"

import "./HrDate.vue?vue&type=style&index=0&id=08a1d525&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08a1d525"]])

export default __exports__
import QDate from 'quasar/src/components/date/QDate.js';
import qInstall from "../../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QDate});
